import axios from 'axios';
import * as Constants from "../common/constants";
import * as HelperFunctions from '../common/functions/helperFunctions';
import { ConditionUnitRangeModel } from '../models/conditionUnitRangeModel';
import { ConditionUnitRangeSettingModel } from '../models/conditionUnitRangeSettingModel';
import AuthService from './authService';

class ConditionUnitTypeService {
    authService = new AuthService();

    constructor() {
        axios.defaults.baseURL = `${Constants.apiUrl}/`;
        axios.defaults.headers = {
            "Content-Type": "application/json; charset=utf-8",
            Authorization: `Bearer ${this.authService.getToken()}`,
            Pragma: 'no-cache'
        }
    }

    getAll(from: number, numberOfRows: number, settings: ConditionUnitRangeSettingModel) {
        return axios({
            url: `adminConditionUnitType/getAll/${from}/${numberOfRows}`,
            method: 'post', headers: {
                "Content-Type": "application/json; charset=utf-8"
            },
            data: JSON.stringify(settings)
        })
            .then(res => res.data.data)
            .catch(error =>
                Promise.reject(HelperFunctions.getErrorMessage(error))
            )
    }

    getById(id: number) {
        return axios({
            url: `adminConditionUnitType/getById/${id}`,
            method: 'get'
        })
            .then(res => res.data.data)
            .catch(error =>
                Promise.reject(HelperFunctions.getErrorMessage(error))
            )
    }

    addConditionUnitType(unitRange: ConditionUnitRangeModel) {
        return axios({
            url: `adminConditionUnitType/create`,
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8"
            },
            data: JSON.stringify(unitRange)
        })
            .then(res => res.data.data)
            .catch(error =>
                Promise.reject(HelperFunctions.getErrorMessage(error))
            )
    }

    editConditionUnitType(id: number, unitRange: ConditionUnitRangeModel) {
        return axios({
            url: `adminConditionUnitType/update/${id}`,
            method: 'put',
            headers: {
                "Content-Type": "application/json; charset=utf-8"
            },
            data: JSON.stringify(unitRange)
        })
            .then(res => res.data.data)
            .catch(error =>
                Promise.reject(HelperFunctions.getErrorMessage(error))
            )
    }

    deleteConditionUnitType(id: number) {
        return axios({
            url: `adminConditionUnitType/delete/${id}`,
            method: 'delete'
        })
            .then(res => res.data.data)
            .catch(error =>
                Promise.reject(HelperFunctions.getErrorMessage(error))
            )
    }
}

export default ConditionUnitTypeService;
